import { useSharedState } from "hooks";
import { searchService } from "services";

const useSearchResult = () => {
  return useSharedState(searchService.result$);
};

export { useSearchResult };
